import React from "react";

export default function SecurityCard() {
  return (
    <div className="settings-card">
      <h3>Security</h3>

      <button className="btn">Change Password</button>
      <button className="btn secondary">Logout All Devices</button>
    </div>
  );
}